export const HORAS_MAXIMAS_DURACION = 87600; // 10 años de 365 días
export const UNIDADES_DURACION = { horas: 1, dias: 24, meses: 720, anios: 8760 };

export function duracionEnHoras(cantidad, unidad) {
  const numero = Number(cantidad);
  const factor = UNIDADES_DURACION[unidad];
  if (!factor || !Number.isInteger(numero) || numero < 1 || numero * factor > HORAS_MAXIMAS_DURACION) {
    throw new Error("Indica una cantidad entera positiva: máximo 10 años.");
  }
  return numero * factor;
}
